import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hamburgerPlus2",
  "use": "hamburgerPlus2-usage",
  "viewBox": "0 0 20 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 14\" id=\"hamburgerPlus2\">\n    <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M12 4H0V6H12V4ZM12 0H0V2H12V0ZM16 8V4H14V8H10V10H14V14H16V10H20V8H16ZM0 10H8V8H0V10Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol